import React from 'react';
import PropTypes from 'prop-types';
import css from './CwRadioButton.scss';

class CwRadioButton extends React.Component {

  componentDidMount() {
    if (this.props.autoFocus) {
      this.wrap.focus();
    }
  }

  handleClick = () => {
    this.input.click();
  }

  handleChange = () => {
    if (this.props.disabled || !this.props.onChange) {
      return;
    }

    this.props.onChange({
        id: this.props.value.id,
        name: this.props.value.name,
        checked: true // anytime a radiobutton is checked, it is selected
    });
  };

  handleKeyPress = (event) => {
    if (this.props.disabled || !this.props.onChange || event.which !== 32) {
      return;
    }

    event.preventDefault(); // prevent scrolling on space key press

    this.props.onChange({
        id: this.props.value.id,
        name: this.props.value.name,
        checked: true // anytime a radiobutton is checked, it is selected
    });
  };

  handleFocus = () => {
    if (this.props.disabled || !this.props.onFocus) {
      return;
    }

    this.props.onFocus();
  }
  handleBlur = () => {
    if (this.props.disabled || !this.props.onBlur) {
      return;
    }

    this.props.onBlur();
  }

  render() {
    return (
      <div data-cwid={this.props.cwId}
        className={css.wrap}
        tabIndex={this.props.disabled ? -1 : this.props.tabIndex}
        disabled={this.props.disabled}
        readOnly={this.props.readOnly}
        ref={(input) => this.wrap = input}
        onKeyPress={this.handleKeyPress}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onClick={this.handleClick}
      >
        <div className={this.props.disabled ? css.controlDisabled : css.control} >
          <input
            ref={(input) => this.input = input}
            type="radio"
            name={this.props.groupName}
            disabled={this.props.disabled}
            onChange={this.handleChange}
            readOnly={this.props.readOnly}
            checked={this.props.value.checked === undefined ? false : this.props.value.checked}
          />
          <div className={this.props.invalid && !this.props.disabled ? css.controlIndicatorInvalid : css.controlIndicator}>
          </div>
          {this.props.value.name ?
            <label className={this.props.invalid && !this.props.disabled ? css.controlLabelInvalid : css.controlLabel}>{this.props.value.name}</label> : null}
        </div>
      </div>
    );
  }
}

CwRadioButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Object of with id, name used to identify the radio button, and checked state
   */
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string,
    checked: PropTypes.bool
  }),
  /**
   * Identifier for group of radio buttons
   */
  groupName: PropTypes.string,
  /**
   * Used to set the radio button to disabled
   */
  disabled: PropTypes.bool,
  /**
   * Callback function fired when radio button changes
   */
  onChange: PropTypes.func,
  /**
   * Used to set the radio button to read only
   */
  readOnly: PropTypes.bool,
  /**
   * Used to control tab order
   */
  tabIndex: PropTypes.number,
  /**
   * Used to control if radiobutton is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Used to display invalid state
   */
  invalid: PropTypes.bool,
};

CwRadioButton.defaultProps = {
  tabIndex: 0
};

export default CwRadioButton;


// WEBPACK FOOTER //
// ./src/components/cwradiobutton/CwRadioButton.jsx